import { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, Legend, PieChart, Pie, Cell } from 'recharts';

const CHART_TICK = { fontSize: 12, fill: '#78716c' };
const TOOLTIP_STYLE = { borderRadius: '8px', border: '1px solid #e7e5e4' };

export const OccupancyBarChart = ({ data }) => (
  <div className="lg:col-span-2 bg-white border border-stone-200 rounded-md p-6">
    <h3 className="font-semibold text-stone-900 font-['Manrope'] mb-4">Occupancy by Room Type</h3>
    {data?.by_room_type?.length > 0 ? (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data.by_room_type}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e7e5e4" />
          <XAxis dataKey="room_type" tick={CHART_TICK} tickFormatter={(value) => value.charAt(0).toUpperCase() + value.slice(1)} />
          <YAxis tick={CHART_TICK} />
          <Tooltip contentStyle={TOOLTIP_STYLE} />
          <Legend />
          <Bar dataKey="total" name="Total Rooms" fill="#78716c" radius={[4, 4, 0, 0]} />
          <Bar dataKey="occupied" name="Occupied" fill="#15803d" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    ) : (
      <div className="flex items-center justify-center h-[300px] text-stone-500">No room data available</div>
    )}
  </div>
);

export const RoomStatusPie = ({ data }) => {
  const occupancyPieData = data?.summary ? [
    { name: 'Occupied', value: data.summary.occupied },
    { name: 'Available', value: data.summary.available },
    { name: 'Maintenance', value: data.summary.maintenance }
  ].filter(d => d.value > 0) : [];

  return (
    <div className="bg-white border border-stone-200 rounded-md p-6">
      <h3 className="font-semibold text-stone-900 font-['Manrope'] mb-4">Room Status</h3>
      {occupancyPieData.length > 0 ? (
        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie data={occupancyPieData} cx="50%" cy="50%" innerRadius={50} outerRadius={80} paddingAngle={2} dataKey="value">
              <Cell fill="#15803d" /><Cell fill="#0369a1" /><Cell fill="#a16207" />
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <div className="flex items-center justify-center h-[200px] text-stone-500">No room data</div>
      )}
      <div className="mt-4 space-y-2">
        {[
          { label: 'Occupied', color: 'bg-emerald-700', value: data?.summary?.occupied || 0 },
          { label: 'Available', color: 'bg-blue-700', value: data?.summary?.available || 0 },
          { label: 'Maintenance', color: 'bg-amber-700', value: data?.summary?.maintenance || 0 },
        ].map(item => (
          <div key={item.label} className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-2">
              <div className={`w-3 h-3 rounded ${item.color}`}></div>
              <span className="text-stone-600">{item.label}</span>
            </div>
            <span className="font-medium text-stone-900">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
